import { FeatureFlag } from '@uptogether/feature-flag-sdk/FeatureFlag'

export default function (context, inject) {
  new FeatureFlag(context, inject).init(true)
}
